import { z } from 'zod';
import { jobListItemSchema } from './jobs.js';
import { leadListItemSchema } from './leads.js';
import { inventoryItemSchema } from './inventory.js';
import { uuidSchema } from './common.js';
const awaitingDepositItemSchema = z.object({
    id: uuidSchema,
    number: z.number(),
    customerName: z.string(),
    depositCents: z.number(),
    sentAt: z.string().nullable(),
});
const monthlyRevenuePointSchema = z.object({ month: z.string(), revenueCents: z.number() });
const leadsBySourcePointSchema = z.object({ source: z.string(), count: z.number() });
export const staffDashboardSchema = z.object({
    role: z.literal('staff'),
    revenueMtdCents: z.number(),
    activeLeads: z.number(),
    openQuotes: z.object({ count: z.number(), valueCents: z.number() }),
    outstandingBalance: z.object({ count: z.number(), valueCents: z.number() }),
    jobsThisWeek: z.number(),
    todayJobs: z.array(jobListItemSchema),
    recentLeads: z.array(leadListItemSchema),
    awaitingDeposit: z.array(awaitingDepositItemSchema),
    lowStock: z.array(inventoryItemSchema),
    creditsBalance: z.number(),
    trialDaysLeft: z.number().nullable(),
    revenueLast6Months: z.array(monthlyRevenuePointSchema),
    leadsBySource: z.array(leadsBySourcePointSchema),
});
export const installerDashboardSchema = z.object({
    role: z.literal('installer'),
    myJobsToday: z.array(jobListItemSchema),
    myUpcoming: z.array(jobListItemSchema),
});
export const dashboardResponseSchema = z.discriminatedUnion('role', [staffDashboardSchema, installerDashboardSchema]);
//# sourceMappingURL=dashboard.js.map